import { Lock } from "@mui/icons-material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";
import { SignOutButton } from "../components/sign-out-button";

interface AccessDeniedPageProps {
  /**
   * Пользователь вошёл, но права просмотра web у него нет — тогда предлагаем выйти.
   * Без сессии (редирект BFF после отказа IMS) — войти снова.
   */
  isSignedIn?: boolean;
}

export const AccessDeniedPage = ({
  isSignedIn = false,
}: AccessDeniedPageProps): JSX.Element => (
  <InfoPageLayout>
    <InfoPage
      title="Нет доступа к EkoCrop"
      message="Обратитесь к администратору, чтобы получить доступ"
      illustration={<InfoPageIllustration icon={Lock} />}
      actions={isSignedIn ? <SignOutButton /> : <SignInButton />}
    />
  </InfoPageLayout>
);
